import request from '@/util/http'
import qs from 'qs'

// 获取全部岗位列表
export const getAllJobList=()=>request({
    url: '/admin/post/list',
    method: 'get'
})

// 获取岗位信息
export const getJobInfo=(id)=>request({
    url: `/admin/post/get/${id}`,
    method: 'get'
})

// 删除岗位
export const handleDelJob=(id)=>request({
    url: `/admin/post/delete/${id}`,
    method: 'delete'
})


// 移出
export const handleOut=(postUserId)=>request({
    url: `/admin/post/out/${postUserId}`,
    method: 'delete'
})


// 调岗
export const handleTransfer=(data)=>request({
    // headers:{
    //     "Content-Type": "application/json"
    // },
    url: '/admin/post/transfer',
    method: 'post',
    data:qs.stringify(data)
})

// 新增或编辑
export const handleSaveOrUpdate=(data)=>request({
    headers:{
        "Content-Type": "application/json"
    },
    url: '/admin/post/saveOrUpdate',
    method: 'post',
    data:JSON.stringify(data)
})

// 分页
export const gettHallPostpage=(params)=>request({
    url: '/admin/post/page',
    method: 'get',
    params
})
